import { ActionTypes } from "../constants/action-types";
const initialState = {
};


export function authReducer(state = initialState, { type, payload }) {
    switch (type) {
        case ActionTypes.SET_AUTH:
            return { ...state, authenticationData: payload };
        default:
            return state;
    }
}